<template>
  <v-container
    fluid
    class="login"
    @keyup.enter="submitForm()"
  >
    <v-flex
      xs12
      md4
      offset-md4
    >
      <v-card ref="card">
        <v-card-text style="text-align: center">
          <img
            alt="logo"
            src="../assets/logo_blue.png"
          >
          <h1 class="primary--text">
            Login Orsegups
          </h1>
        </v-card-text>
        <v-card-text>
          <v-form v-model="isFormValid">
            <v-text-field
              ref="username"
              v-model="username"
              :rules="usernameRules"
              label="Login"
              placeholder="Acesse com: Email ou Username."
              required
            />
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="passwordRules"
              :type="showPassword ? 'text' : 'password'"
              name="input-10-2"
              label="Senha"
              placeholder="Digite sua senha"
              class="input-group--focused"
              @click:append="showPassword = !showPassword"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="recover()"
          >
            Esqueci minha senha
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            rounded
            :disabled="!isFormValid"
            @click="submitForm()"
          >
            Acessar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>


    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      max-width="600px"
    >
      <v-card>
        <v-card-title style="background-color: var(--primary-color-3); color: white">
          Termos de Uso
        </v-card-title>
        <v-divider />
        <v-card-text
          style="
          height: 500px;
          white-space: pre-line;
          font-family: ARIAL, serif;
          font-style: italic;"
        >
          {{ getContractText() }}
        </v-card-text>
        <v-divider />
        <v-card-actions class="justify-center">
          <v-btn
            color="primary"
            rounded
            class="justify-right"
            @click="submitContract()"
          >
            Aceitar e Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const login = createNamespacedHelpers('login');
const contract = createNamespacedHelpers('views/contract');

export default {
  name: 'Login',
  data: () => ({
    username: null,
    showPassword: false,
    password: null,
    isFormValid: false,
    emailRule: null,
    email: null,
    dialog: false,
  }),
  computed: {
    ...login.mapState([
      'overlay',
    ]),
    ...contract.mapState([
      'contractText',
      'contractId',
    ]),
    emailRules() {
      return [
        this.$rules.email(),
      ];
    },
    usernameRules() {
      return [
        this.$rules.required(),
        // TODO: add these validations eventually
        // rules.username(),
        // rules.cpfCnpj(),
        // rules.email(),
      ];
    },
    passwordRules() {
      return [
        this.$rules.required(),
        this.$rules.min(4),
      ];
    },
  },
  methods: {
    ...contract.mapActions([
      'findContract',
      'findUserContract',
      'createUserContract',
    ]),
    ...contract.mapGetters([
      'getContractText',
    ]),
    ...login.mapMutations([
      'setOverlay',
      'setRecEmail',
    ]),
    ...login.mapActions(['login', 'logout']),
    submitForm() {
      this.setOverlay(true);
      this.submit();
    },
    recover() {
      if (typeof this.$rules.email()(this.username) === 'string') {
        this.setRecEmail('');
      } else {
        this.setRecEmail(this.username);
      }
      this.$router.push(
        {
          name: 'Recover',
        },
      );
    },
    submit() {
      this.login({
        username: this.username,
        password: this.password,
        onSuccess: () => this.findUserContract({
          email: this.username,
          onSuccess: () => {
            this.$router.push(this.$router.currentRoute.query.redirect ? {
              path: this.$router.currentRoute.query.redirect,
            } : {
              name: 'Dashboard',
            });
          },
          onError: () => {
            this.dialog = true;
            this.findContract();
          },
        }),
        onLogout: () => this.$router.push({
          name: 'Login',
        }),
      });
    },
    submitContract() {
      this.dialog = false;
      this.setOverlay(true);
      this.createUserContract({
        username: this.username,
        password: this.password,
        onSuccess: () => this.$router.push({
          name: 'Dashboard',
        }),
        onError: () => {
          this.setOverlay(false);
        },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.login /deep/ {
  .theme--light.v-sheet {
      border-radius: 10px;
      margin-top: 10vh;
      padding: 20px 30px 25px;
  }
  .theme--light.v-sheet h1 { font-weight: normal }
  .v-btn {
    text-transform: none;
  }
  .v-card__text input {
    padding-left: 5px;
    font-size: 14px;
  }
}
</style>
